<mat-card class="standardized">
    <div class="widget-title">Current Lien Information</div>
    <div class="Vert-5"></div>
    <div *ngIf="currentLienWidgetData?.length > 1">
        <div style="font-size: 13px;" *ngIf="currentLien===1"><a style="color: #404040!important;"
                (click)="showLien(0)">Primary Lien</a> &nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;
            <span style="background: #E5E7E8; padding: 5px 10px;border-radius: 25px;font-weight: bold;">Second
                Lien</span>
        </div>
        <div style="font-size: 13px;" *ngIf="currentLien===0"> <span
                style="background: #E5E7E8; padding: 5px 10px;border-radius: 25px;font-weight: bold;">Primary
                Lien</span> &nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;<a style="color: #404040!important;"
                (click)="showLien(1)">Second Lien</a>
        </div>
        <div class="Vert-15"></div>
    </div>
    <div *ngIf="currentLienWidgetData?.length>0; else noLien">
        <div *ngIf="currentLienWidgetData[currentLien] as currentLienData">
            <div class="float-left">
                <span class="standOutText" style="font-size: 16px !important;">
                    {{currentLienData?.mortgageRate | number : '1.3-3'}}%
                    Rate
                    |
                    {{currentLienData?.mortgageLoanType }}
                    |
                    {{(currentLienData?.mortgageTerm /12) | number :
                    '1.0-2'}} Year Term
                </span>
            </div>

            <div class="Vert-15"></div>

            <!-- <span class="label">Balance: </span>${{currentLienData?.loanAmount | number :
            '1.0-0'}} -->
            <div class="Vert-5"></div>
            <span class="label">Transaction Date: </span>{{currentLienData?.transactionDate | date:'MM/dd/yy'}}
            <div class="Vert-5"></div>
            <span class="label">Final Payment: </span>{{currentLienData?.dueDate |
            date:'MM/dd/yy'}}
            <div class="Vert-5"></div>
            <span class="label">Original Amt: </span>${{currentLienData?.loanAmount |
            number : '1.0-0'}}
            <div class="Vert-5"></div>
            <span class="label">Lender: </span>{{currentLienData?.lender}}
            <div class="Vert-5"></div>
            <span class="label">Loan Type: </span>{{currentLienData?.mortgageLoanType}}
            <div class="Vert-5"></div>

        </div>
    </div>
    <ng-template #noLien>
        No liens were found.
    </ng-template>

</mat-card>